/* eslint-disable no-console */
import {
  FETCH_FUTURE_BOT_HISTORY,
  FETCH_FUTURE_BOT_HISTORY_ERROR,
} from '../types';

const initialState = {
  futureBotHistoryData: [],
  success: false,
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_FUTURE_BOT_HISTORY:
      console.log('FETCH_FUTURE_BOT_HISTORY Payload:', action.payload);
      return {
        ...state,
        futureBotHistoryData: action.payload,
        success: true,
        loading: false,
      };

    case FETCH_FUTURE_BOT_HISTORY_ERROR:
      console.error('FETCH_FUTURE_BOT_HISTORY_ERROR:', action.payload);
      return {
        ...state,
        success: false,
        loading: true,
      };

    default:
      console.log('Unknown Action:', action.type);
      return state;
  }
}
